"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleValueType = exports.RuleTargetDataType = exports.RuleTag = exports.RuleStatus = exports.RuleType = void 0;
var RuleType;
(function (RuleType) {
    RuleType["INSTITUTION"] = "INSTITUTION";
    RuleType["ACADEMIC_GROUP"] = "ACADEMIC_GROUP";
})(RuleType = exports.RuleType || (exports.RuleType = {}));
var RuleStatus;
(function (RuleStatus) {
    RuleStatus["ACTIVE"] = "ACTIVE";
    RuleStatus["INACTIVE"] = "INACTIVE";
})(RuleStatus = exports.RuleStatus || (exports.RuleStatus = {}));
var RuleTag;
(function (RuleTag) {
    RuleTag["INFO"] = "INFO";
    RuleTag["WARNING"] = "WARNING";
})(RuleTag = exports.RuleTag || (exports.RuleTag = {}));
var RuleTargetDataType;
(function (RuleTargetDataType) {
    RuleTargetDataType["APPLICANT"] = "APPLICANT";
    RuleTargetDataType["APPLICATION"] = "APPLICATION";
    RuleTargetDataType["COURSE"] = "COURSE";
    RuleTargetDataType["CREDENTIAL"] = "CREDENTIAL";
})(RuleTargetDataType = exports.RuleTargetDataType || (exports.RuleTargetDataType = {}));
var RuleValueType;
(function (RuleValueType) {
    RuleValueType["NUMBER"] = "NUMBER";
    RuleValueType["STRING"] = "STRING";
    RuleValueType["ENUM"] = "ENUM";
    RuleValueType["DATE"] = "DATE";
})(RuleValueType = exports.RuleValueType || (exports.RuleValueType = {}));
//# sourceMappingURL=RuleCommon.js.map